import axios from 'axios';
import { ManualFeedsCustomer } from 'views/feed-management/features/manual-feeds/types/manual-feeds-customer.type';

// GET
// Returns list of companies.
// ​/ewosapi​/v1​/feeds/manual/company/{globalCompanyId}​/customer
export const getManualFeedsCustomers = async (globalCompanyId: string): Promise<ManualFeedsCustomer[]> => {
  const res = await axios.get<ManualFeedsCustomer[]>(`/ewosapi/v1/feeds/manual/company/${globalCompanyId}/customer`);
  return res.data;
};
